export const REFERENCE_OP_COUNT_SETTING_MIN = 1;        // 基準操作回数設定（最小値）
export const REFERENCE_OP_COUNT_SETTING_MAX = 4500;     // 基準操作回数設定（最大値）
export const REFERENCE_OP_COUNT_SETTING_DEFAULT = 450;  // 基準操作回数設定（デフォルト値）
